module.exports = __webpack_public_path__ + "static/media/CriticalIllness.dca27511.svg";